export default __webpack_public_path__ + "static/media/coming.6542b1aa.png";